import { CropManagementImport } from './Imports'
const { RoutesMap, CropStageMasterList, CropScheduleVariantList, DayWiseScheduleList, AddDayWiseSchedule, UpdateDayWiseSchedule, DayWiseScheduleDetails } = CropManagementImport

const CropManagementRoute = () => {
    return [
        {
            path: RoutesMap.CROP_STAGE_MASTER_LIST.path,
            element: <CropStageMasterList />
        },

        {
            path: RoutesMap.CROP_SCHEDULE_VARIANT_LIST.path,
            element: <CropScheduleVariantList />
        },

        {
            path: RoutesMap.DAY_WISE_SCHEDULE_LIST.path,
            element: <DayWiseScheduleList />
        },

        {
            path: RoutesMap.ADD_DAY_WISE_SCHEDULE.path,
            element: <AddDayWiseSchedule />
        },

        {
            path: RoutesMap.UPDATE_DAY_WISE_SCHEDULE.path,
            element: <UpdateDayWiseSchedule />
        },

        {
            path: RoutesMap.DAY_WISE_SCHEDULE_DETAILS.path,
            element: <DayWiseScheduleDetails />
        },
    ]
}

export default CropManagementRoute;
